export default {
  FETCH_ALL_CAFE_EVENTS_FAILED: 'FETCH_ALL_CAFE_EVENTS_FAILED',
  FETCH_ALL_CAFE_EVENTS_REJECT: 'FETCH_ALL_CAFE_EVENTS_REJECT',
  FETCH_ALL_CAFE_EVENTS_LOADING: 'FETCH_ALL_CAFE_EVENTS_LOADING',
  FETCH_ALL_CAFE_EVENTS_SUCCESS: 'FETCH_ALL_CAFE_EVENTS_SUCCESS',

  FETCH_ALL_ARCHIVED_CAFE_EVENTS_FAILED: 'FETCH_ALL_ARCHIVED_CAFE_EVENTS_FAILED',
  FETCH_ALL_ARCHIVED_CAFE_EVENTS_REJECT: 'FETCH_ALL_ARCHIVED_CAFE_EVENTS_REJECT',
  FETCH_ALL_ARCHIVED_CAFE_EVENTS_LOADING: 'FETCH_ALL_ARCHIVED_CAFE_EVENTS_LOADING',
  FETCH_ALL_ARCHIVED_CAFE_EVENTS_SUCCESS: 'FETCH_ALL_ARCHIVED_CAFE_EVENTS_SUCCESS',

  FETCH_ALL_REQUESTED_CAFE_EVENTS_FAILED: 'FETCH_ALL_REQUESTED_CAFE_EVENTS_FAILED',
  FETCH_ALL_REQUESTED_CAFE_EVENTS_REJECT: 'FETCH_ALL_REQUESTED_CAFE_EVENTS_REJECT',
  FETCH_ALL_REQUESTED_CAFE_EVENTS_LOADING: 'FETCH_ALL_REQUESTED_CAFE_EVENTS_LOADING',
  FETCH_ALL_REQUESTED_CAFE_EVENTS_SUCCESS: 'FETCH_ALL_REQUESTED_CAFE_EVENTS_SUCCESS',

  FETCH_CAFE_EVENT_BY_ID_FAILED: 'FETCH_CAFE_EVENT_BY_ID_FAILED',
  FETCH_CAFE_EVENT_BY_ID_REJECT: 'FETCH_CAFE_EVENT_BY_ID_REJECT',
  FETCH_CAFE_EVENT_BY_ID_LOADING: 'FETCH_CAFE_EVENT_BY_ID_LOADING',
  FETCH_CAFE_EVENT_BY_ID_SUCCESS: 'FETCH_CAFE_EVENT_BY_ID_SUCCESS',

  ADD_CAFE_EVENT_FAILED: 'ADD_CAFE_EVENT_FAILED',
  ADD_CAFE_EVENT_REJECT: 'ADD_CAFE_EVENT_REJECT',
  ADD_CAFE_EVENT_LOADING: 'ADD_CAFE_EVENT_LOADING',
  ADD_CAFE_EVENT_SUCCESS: 'ADD_CAFE_EVENT_SUCCESS',

  UPDATE_CAFE_EVENT_FAILED: 'UPDATE_CAFE_EVENT_FAILED',
  UPDATE_CAFE_EVENT_REJECT: 'UPDATE_CAFE_EVENT_REJECT',
  UPDATE_CAFE_EVENT_LOADING: 'UPDATE_CAFE_EVENT_LOADING',
  UPDATE_CAFE_EVENT_SUCCESS: 'UPDATE_CAFE_EVENT_SUCCESS',

  REJECT_CAFE_EVENT_FAILED: 'REJECT_CAFE_EVENT_FAILED',
  REJECT_CAFE_EVENT_REJECT: 'REJECT_CAFE_EVENT_REJECT',
  REJECT_CAFE_EVENT_LOADING: 'REJECT_CAFE_EVENT_LOADING',
  REJECT_CAFE_EVENT_SUCCESS: 'REJECT_CAFE_EVENT_SUCCESS',

  DISABLE_CAFE_EVENT_FAILED: 'DISABLE_CAFE_EVENT_FAILED',
  DISABLE_CAFE_EVENT_REJECT: 'DISABLE_CAFE_EVENT_REJECT',
  DISABLE_CAFE_EVENT_LOADING: 'DISABLE_CAFE_EVENT_LOADING',
  DISABLE_CAFE_EVENT_SUCCESS: 'DISABLE_CAFE_EVENT_SUCCESS',

  CONFIRM_CAFE_EVENT_FAILED: 'CONFIRM_CAFE_EVENT_FAILED',
  CONFIRM_CAFE_EVENT_REJECT: 'CONFIRM_CAFE_EVENT_REJECT',
  CONFIRM_CAFE_EVENT_LOADING: 'CONFIRM_CAFE_EVENT_LOADING',
  CONFIRM_CAFE_EVENT_SUCCESS: 'CONFIRM_CAFE_EVENT_SUCCESS',

  CLEAR_ADD_EVENT_FORM: 'CLEAR_ADD_EVENT_FORM'
};
